import { c as e } from "react/compiler-runtime";
import { FormattedMessage as t } from "react-intl";
import { useId as n } from "react";
import { Link as r } from "compatibility-router";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/general/components/settings-side-panel.module.css
var o = "_content_1ke2a_17", s = {
	"side-panel": "_side-panel_1ke2a_1",
	"settings-header": "_settings-header_1ke2a_9",
	content: o
}, c = { link: "_link_1he2v_1" };
//#endregion
//#region src/general/components/settings-side-panel/link.tsx
function l(t) {
	let n = e(3), { to: a, children: o } = t, s;
	return n[0] !== o || n[1] !== a ? (s = /* @__PURE__ */ i("li", { children: /* @__PURE__ */ i(r, {
		className: c.link,
		to: a,
		children: o
	}) }), n[0] = o, n[1] = a, n[2] = s) : s = n[2], s;
}
var u = { list: "_list_17ali_1" };
//#endregion
//#region src/general/components/settings-side-panel/list.tsx
function d(t) {
	let n = e(2), { children: r } = t, a;
	return n[0] === r ? a = n[1] : (a = /* @__PURE__ */ i("ul", {
		className: u.list,
		children: r
	}), n[0] = r, n[1] = a), a;
}
//#endregion
//#region src/general/components/settings-side-panel/section.tsx
function f(t) {
	let n = e(2), { children: r } = t, a;
	return n[0] === r ? a = n[1] : (a = /* @__PURE__ */ i("li", { children: r }), n[0] = r, n[1] = a), a;
}
var p = { title: "_title_kbl7u_1" };
//#endregion
//#region src/general/components/settings-side-panel/title.tsx
function m(t) {
	let n = e(2), { children: r } = t, a;
	return n[0] === r ? a = n[1] : (a = /* @__PURE__ */ i("h4", {
		className: p.title,
		children: r
	}), n[0] = r, n[1] = a), a;
}
//#endregion
//#region src/general/components/settings-side-panel.tsx
function h(r) {
	let o = e(9), { children: c } = r, l = n(), u;
	o[0] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ i(t, { id: "menu.settings" }), o[0] = u) : u = o[0];
	let d;
	o[1] === l ? d = o[2] : (d = /* @__PURE__ */ i("div", {
		className: s["settings-header"],
		children: /* @__PURE__ */ i("h4", {
			id: l,
			children: u
		})
	}), o[1] = l, o[2] = d);
	let f;
	o[3] === c ? f = o[4] : (f = /* @__PURE__ */ i("ul", {
		className: s.content,
		children: c
	}), o[3] = c, o[4] = f);
	let p;
	return o[5] !== l || o[6] !== d || o[7] !== f ? (p = /* @__PURE__ */ a("nav", {
		"aria-labelledby": l,
		className: s["side-panel"],
		children: [d, f]
	}), o[5] = l, o[6] = d, o[7] = f, o[8] = p) : p = o[8], p;
}
h.Section = f, h.Title = m, h.List = d, h.Link = l;
//#endregion
//#region src/daas-settings-side-panel.tsx
function g() {
	let n = e(3), r;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ i(h.Title, { children: /* @__PURE__ */ i(t, { id: "settings.section.personal_settings" }) }), n[0] = r) : r = n[0];
	let o;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ i(h.Link, {
		to: "/daas/$destinationId/settings/personal",
		children: /* @__PURE__ */ i(t, { id: "settings.personal.title" })
	}), n[1] = o) : o = n[1];
	let s;
	return n[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i(h, { children: /* @__PURE__ */ a(h.Section, { children: [r, /* @__PURE__ */ a(h.List, { children: [o, /* @__PURE__ */ i(h.Link, {
		to: "/daas/$destinationId/settings/theme",
		children: /* @__PURE__ */ i(t, { id: "settings.theme.title" })
	})] })] }) }), n[2] = s) : s = n[2], s;
}
//#endregion
//#region src/hotel-settings-side-panel.tsx
function _() {
	let n = e(3), r;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ i(h.Title, { children: /* @__PURE__ */ i(t, { id: "settings.section.personal_settings" }) }), n[0] = r) : r = n[0];
	let o;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ i(h.Link, {
		to: "/hotel/$hotelId/settings/personal",
		children: /* @__PURE__ */ i(t, { id: "settings.personal.title" })
	}), n[1] = o) : o = n[1];
	let s;
	return n[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i(h, { children: /* @__PURE__ */ a(h.Section, { children: [r, /* @__PURE__ */ a(h.List, { children: [o, /* @__PURE__ */ i(h.Link, {
		to: "/hotel/$hotelId/settings/theme",
		children: /* @__PURE__ */ i(t, { id: "settings.theme.title" })
	})] })] }) }), n[2] = s) : s = n[2], s;
}
//#endregion
//#region src/market-settings-side-panel.tsx
function v() {
	let n = e(3), r;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ i(h.Title, { children: /* @__PURE__ */ i(t, { id: "settings.section.personal_settings" }) }), n[0] = r) : r = n[0];
	let o;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ i(h.Link, {
		to: "/market/$marketId/settings/personal",
		children: /* @__PURE__ */ i(t, { id: "settings.personal.title" })
	}), n[1] = o) : o = n[1];
	let s;
	return n[2] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i(h, { children: /* @__PURE__ */ a(h.Section, { children: [r, /* @__PURE__ */ a(h.List, { children: [o, /* @__PURE__ */ i(h.Link, {
		to: "/market/$marketId/settings/theme",
		children: /* @__PURE__ */ i(t, { id: "settings.theme.title" })
	})] })] }) }), n[2] = s) : s = n[2], s;
}
//#endregion
export { g as DaasSettingsSidePanel, _ as HotelSettingsSidePanel, v as MarketSettingsSidePanel };
